import { I18n } from '@aws-amplify/core';
import { Form } from 'antd';
import { NamePath } from 'antd/lib/form/interface';

interface ActivityDurationProps {
	fieldName?: string | string[];
}

const { useWatch } = Form;

export function useActivityDuration({ fieldName }: ActivityDurationProps) {
	const field = Array.isArray(fieldName) ? fieldName[0] : null;
	const workdayPath: NamePath = field ? [field, 'workday_duration'] : 'workday_duration';

	const workdayDuration = useWatch(workdayPath);

	function activityDurationValidator(_: unknown, value: number): Promise<void> {
		if (value != null && value > workdayDuration) {
			return Promise.reject(new Error(I18n.get('Activity duration cannot be greater than day duration')));
		}
		return Promise.resolve();
	}

	return {
		workdayPath,
		activityDurationValidator
	};
}
